import React, { useEffect } from "react";
import PageNameBanner from "../../components/page-name-banner/PageNameBanner";
import ImageAside from "../../components/image-aside/Image-aside";
import { aboutImage, tinyAboutImage } from "../../assets";
import "./About.css";
import { useNavigate } from "react-router-dom";

const mainText = "About Us";
const paragraphText =
  "Welcome to One Life Equity Fund LP, your trusted partner in creative and expert lending solutions. With years of experience in the financial industry, we specialize in providing private lending services tailored to meet the unique needs of our clients. Whether you're looking for bridge loans, term loans, or short-term lending, we offer flexible and innovative financing options designed to help you achieve your financial goals.";
const buttonText = "Meet Our Team";

export default function About() {

  return (
    <div>
      <PageNameBanner pageName="About Us" />
      <div className="about">
        <ImageAside
          mainText={mainText}
          buttonText={buttonText}
          mainParagraph={paragraphText}
          imageSrc={aboutImage}
          tinyImageSrc={tinyAboutImage}
          buttonEventHandler={() => document.getElementById('our-team')?.scrollIntoView({ behavior: 'smooth' })}
        />

<div className="about-content">



<div>

  <h2>Our Expertise</h2>
  
  <p>At One Life Equity Fund LP, we pride ourselves on our deep understanding of the lending landscape. Our team of seasoned professionals has a proven track record in the industry, enabling us to navigate complex financial situations with ease. We are experts in structuring deals that work for our clients, ensuring that each loan is customized to fit their specific requirements and circumstances.</p>
</div>
<div>
  
  <h2>Creative Solutions</h2>
  
  <p>We believe that every client is unique, and so are their financial needs. That's why we take a creative approach to lending. Our ability to think outside the box allows us to provide solutions that other lenders might not offer. Whether you need quick access to funds through a bridge loan, a longer-term financing solution, or short-term lending to cover immediate expenses, we have the expertise and flexibility to provide the best possible options.</p>
</div>
<div>
  
  <h2>Our Commitment</h2>
  
  <p>At the core of our business is a commitment to excellence and integrity. We understand that taking out a loan is a significant decision, and we are dedicated to making the process as smooth and transparent as possible. Our team is always available to answer your questions, provide guidance, and support you throughout the lending process.</p>
</div>
<div>
  
  <h2>Why Choose Us?</h2>
  <ul>
  <li>Experience: Our team has extensive experience in the private lending sector, giving us the insight needed to offer top-tier financial solutions.</li>
  
  <li>Flexibility: We offer a wide range of lending products, including bridge loans, term loans, and short-term lending, with terms that can be tailored to your specific needs.</li>
  
  <li>Creativity: We excel in crafting innovative financing solutions, even for complex or unusual situations.</li>
  
  <li>Customer Focus: Your satisfaction is our priority. We work closely with each client to ensure their financial needs are met with the highest level of service and professionalism.</li>
  </ul>
</div>
<div>
  
  <h2>Our Mission</h2>
  
  <p>Our mission is to empower individuals and businesses by providing accessible and creative lending solutions. We strive to build lasting relationships with our clients, offering not just financial support but also peace of mind knowing they have a reliable partner in their financial journey.</p>
</div>
<div>
  
  <h2>Contact Us</h2>
  
  <p>Ready to explore your lending options? Contact One Life Equity Fund LP today to learn more about how we can help you achieve your financial goals. Whether you're looking for a bridge loan, term loan, or short-term lending solution, we are here to provide the expert guidance and support you need</p>
</div>

<h1 className="team" id="our-team">Our Team</h1>
<div>
  
  <h2>Rasik Patel</h2>
  
  <p>Rasik Patel, a longtime Hampton, Virginia resident, and President of RKP Financial & Investments, is a
first-generation American Indian entrepreneur who built his business from the ground up. Over the
years, he has developed a diverse portfolio that includes convenience stores, retail shopping centers,
hotels, and mixed-use properties along the East Coast. Rasik’s group, through direct ownership or LLCs,
operates convenience stores, hotels, shopping centers, and mixed-use properties. Additionally, he runs
his own finance company, offering custom-tailored financing solutions to small businesses and
developers.
<br/>
<br/>
With years of lending experience, Rasik excels in his role, backed by strong networking skills and longlasting client relationships. He is widely regarded as a mentor, with many of his clients achieving
extraordinary success thanks to his creative lending strategies. His early involvement in helping
businesses secure funding has allowed countless entrepreneurs to grow their companies into
exceptional organizations.
<br/>
<br/>
Rasik immigrated to the U.S. in 1990 and has been a resident of Hampton since 2003. He is an active
member of the Virginia Asian American Store Owners Association (VAASOA) and the Asian American
Hotel Owners Association (AAHOA). Beyond his business endeavors, Rasik is deeply committed to
philanthropy, contributing to causes in the Hampton area through Rotary International and the Lions
Club.
<br/>
<br/>
A dedicated advocate for a healthy lifestyle, Rasik is a passionate cricket batsman and a longtime
member of the Hampton Roads Cricket Organization.
</p>
</div>
<div>
  
  <h2>Arun Patel</h2>
  
  <p>Arun Patel, a long-term resident of New Jersey and a graduate of Rutgers University College of
Engineering, has over 30 years of experience as an IT consultant specializing in full-stack development,
deployment, upgrades, and security for online applications, systems, networks, and third-party SaaS
solutions. His diverse background spans multiple sectors, including e-commerce, real estate, travel,
telecom, and finance.
<br/>
<br/>
A serial entrepreneur, Arun has successfully invested in motels, apartment and office buildings,
convenience stores, and various other ventures over the past four decades. He has also played
leadership roles in prominent associations such as IATANA and
IEEE (Institute of Electrical and Electronics Engineers), bringing a wealth of industry knowledge to every
investment.
<br/>
<br/>
Arun co-founded Prime Capital Investors LLC with the goal of expanding investment opportunities for
others, emphasizing a balanced approach to risk and return. Beyond his business endeavors, he is a
dedicated philanthropist, advocating for causes related to blindness and education in India, as well as
supporting children’s cancer research in the United States.
</p>
</div>

<div>
  
  <h2>Vijay Patel</h2>
  
  <p>Vijay Patel, a longtime Tampa Bay resident, embodies the American dream. After immigrating to the U.S.
in 1996 from a small village in Gujarat, India, Vijay began his journey as an employee before purchasing
his first gas station in Saint Petersburg, Florida, in 2002. Through refining systems to boost inside sales
and profitability, he expanded his portfolio. In 2008, Vijay seized a key opportunity to acquire 22 gas
stations in Ocala, Florida, rebranding them as Quick King. This success led to the ownership of over 100
retail stores nationwide, with integrated real estate holdings. To streamline his business, he launched
his own fuel distribution company, supplying both his stores and external clients.
<br/>
<br/>
His investments span diverse sectors, including restaurant chains such as Subway and Dunkin’ Donuts, as
well as health, insurance, and banking. In 2013, Vijay ventured into hospitality, acquiring over 50 hotels,
including leading brands like Marriott, Holiday Inn, and Hampton Inn. He founded a management
company to oversee his hotel holdings and established a development firm that focuses on constructing
hotels, storage spaces, apartment complexes, and retail centers.
<br/>
<br/>
A dedicated philanthropist, Vijay supports his community not only through donations but also active
involvement. As a sought-after mentor, he spends his time guiding others toward success.
</p>
</div>

<div>
  
  <h2>Gautam Patel</h2>
  
  <p>Gautam Patel, a longtime resident of Washington, DC, exemplifies resilience and entrepreneurial spirit.
Originally trained as a mechanical engineer in Gujarat, India, his journey took a new direction after
immigrating to the U.S. in the early 2000s. In 2002, Gautam opened his first liquor store, marking the
start of a thriving business venture. Through hard work and determination, he expanded his portfolio to
include multiple stores and retail shopping centers across Maryland.
<br/>
<br/>
Beyond his business successes, Gautam is an active and well-regarded member of the Asian American
Retailers Association of Maryland (AARA), where he dedicates time, effort, and financial support to
various local causes, reflecting his commitment to giving back to the community.
<br/>
<br/>
Education holds a central place in Gautam's values. His children have excelled academically, attending
prestigious institutions such as Carey Law School, the University of Maryland Baltimore County (UMBC),
and Indian Creek School. Gautam’s journey is a testament to transformation, community involvement,
and a deep appreciation for education.
</p>
</div>

<div>
  
  <h2>Dhaval Patel</h2>
  
  <p>Longtime Kentucky Bluegrass state resident, Dhaval Patel has a strong foundation in family business and
has developed a diverse and extensive career in the business world. Today, he leads a large wholesale
distribution operation and a management company overseeing various enterprises, including hotels, car
washes, gas stations, private lending, and construction projects.
<br/>
<br/>
As a hands-on leader, Dhaval takes pride in working alongside a talented team that shares his
commitment to excellence. Together, they turn ideas into reality, achieving success where others see
challenges. Dhaval’s team’s growth is built on a foundation of teamwork, innovation, and core values
<br/>
<br/>
Dhaval’s mission is to unlock potential to create opportunities—whether for his businesses or the
individuals he works with. He is passionate about helping others reach their fullest potential, fostering
both personal and professional growth in every endeavor.
<br/>
<br/>
Dhaval’s motivation comes from seeing others grow into something they never thought possible. One
person at a time, he is committed to making a positive impact in the community.
<br/>
<br/>
With extensive experience in the financial world, Dhaval has developed creative approaches to providing
the funding needed for growth. His passion for technology drives him to stay innovative, continuously
learning and adapting every day.
</p>
</div>

</div>      
      </div>
    </div>



  );
}
